import "./Banner.scss";
import "../../styles/index.scss";
import {useNavigate} from "react-router-dom";
import {useState, useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser} from "@fortawesome/free-solid-svg-icons";
import {faBars, faXmark} from "@fortawesome/free-solid-svg-icons";
import {
    faFacebook,
    faInstagram,
    faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import Cookies from "js-cookie";
import ButtonDeconnect from "../Button Deconnect/ButtonDeconnect";

function Banner() {
    const [profilClique, setProfilClique] = useState(false);
    const cart = JSON.parse(localStorage.getItem("cart"));
    const nbArticles = cart ? cart.length : 0;
    const [mobileMenuClique, setMobileMenuClique] = useState(false);
    const jwtToken = Cookies.get("auth_token");
    const name = Cookies.get("name");
    const navigate = useNavigate();

    useEffect(() => {
        if (cart) {
            localStorage.setItem("nbArticles", JSON.stringify(cart.length));
        }
    }, [cart]);

    useEffect(() => {
        if (nbArticles > 0) {
            localStorage.setItem("nbArticles", JSON.stringify(nbArticles));
        }
    }, [nbArticles]);

    const clickNavBarItem = (direction) => {
        navigate("/" + direction);
        setMobileMenuClique(false);
    }

    const handleClickSocials = (redirection) => {
        redirection === "facebook"
            ? window.open(
                "https://www.facebook.com/profile.php?id=100075994402255",
                "_blank"
            )
            : redirection === "instagram"
                ? window.open(
                    "https://www.instagram.com/anneso2273/?igshid=OGQ5ZDc2ODk2ZA%3D%3D",
                    "_blank"
                )
                : window.open("https://www.tiktok.com/@krystalpassion22", "_blank");
    };

    useEffect(() => {
        if (jwtToken && profilClique) {
            const fetchData = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_API_URL}users`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${jwtToken}`,
                        },
                    });
                    const user = await response.json();
                    if (user.role === "admin") {
                        navigate("/admin");
                    } else if (user) {
                        navigate("/profil/infos-persos", {
                            state: {
                                id: user.id,
                                nom: user.nom,
                                prenom: user.prenom,
                                adresseEmail: user.adresseEmail,
                                numeroTel: user.numeroTel,
                            },
                        });
                    }
                } catch (error) {
                    console.error("Erreur de connexion au serveur:", error);
                } finally {
                    setProfilClique(false);
                    setMobileMenuClique(false);
                }
            };
            fetchData();
        } else if (profilClique) {
            navigate("/auth/login");
            setProfilClique(false);
            setMobileMenuClique(false);
        }
    }, [profilClique, jwtToken, navigate]);

    useEffect(() => {
        if (mobileMenuClique) {
            document.documentElement.classList.add('overflow-hidden');
        } else {
            document.documentElement.classList.remove('overflow-hidden');
        }

        return () => {
            document.documentElement.classList.remove('overflow-hidden');
        };
    }, [mobileMenuClique]);

    return (
        <header className="lmj-banner">
            <div className="banner-mobile">
                <h2 id="banner-title" onClick={() => clickNavBarItem("")} style={{cursor: "pointer"}}>Anne'so Naturelle</h2>
                <FontAwesomeIcon 
                    id="icon-menu-mobile" 
                    icon={mobileMenuClique ? faXmark : faBars} 
                    size="2x"
                    onClick={() => setMobileMenuClique(!mobileMenuClique)}
                    style={{cursor: "pointer"}}
                />
            </div>
            
            <div className="second-barre-banner">
                <div className="icon-socials-banner">
                    <FontAwesomeIcon
                        className="iconSocial"
                        icon={faFacebook}
                        onClick={() => handleClickSocials("facebook")}
                    />
                    <FontAwesomeIcon
                        className="iconSocial"
                        icon={faInstagram}
                        onClick={() => handleClickSocials("instagram")}
                    />
                    <FontAwesomeIcon
                        className="iconSocial"
                        icon={faTiktok}
                        onClick={() => handleClickSocials("tiktok")}
                    />
                </div>
                
                <nav className="div-liens-pc">
                    <span className="lmj-title" onClick={() => clickNavBarItem("")}>Accueil</span>
                    <span className="lmj-title" onClick={() => clickNavBarItem("collections")}>Collections</span>
                    <span className="lmj-title" onClick={() => clickNavBarItem("creations-personnalisees")}>Créations Personnalisées</span>
                    <span className="lmj-title" onClick={() => clickNavBarItem("apropos")}>Mon histoire</span>
                    <span className="lmj-title" onClick={() => clickNavBarItem("contact")}>Contact</span>
                </nav>
                
                <div className="right-icons-container">
                    <div className="div-icon-login-navbar" onClick={() => setProfilClique(true)}>
                        <FontAwesomeIcon id="icon-user-a" icon={faUser} size="2x" />
                        <p className="name-under-login-icon-navbar">{name ? name : "Me connecter"}</p>
                    </div>

                    <div className="icon-header-container" onClick={() => navigate('/panier')}>
                        <div className="div-icon-basket-navbar">
                            <img
                                src="https://res.cloudinary.com/dc1p20eb2/image/upload/v1715033488/Anne%27so%20Naturelle/Image/basket.svg"
                                alt="icone panier"
                                id="icone_panier"
                            />
                            {nbArticles > 0 && <span className="span-nb-articles">{nbArticles}</span>}
                        </div>
                        <p className="name-under-basket-icon-navbar">Panier</p>
                    </div>
                </div>
            </div>

            <div className={`mobile-banner ${mobileMenuClique ? 'active' : ''}`}>
                <FontAwesomeIcon 
                    icon={faXmark} 
                    className="close-menu-btn"
                    onClick={() => setMobileMenuClique(false)} 
                />
                
                <div className="icon-socials-banner-mobile">
                    <FontAwesomeIcon className="iconSocial" icon={faFacebook} onClick={() => handleClickSocials("facebook")} />
                    <FontAwesomeIcon className="iconSocial" icon={faInstagram} onClick={() => handleClickSocials("instagram")} />
                    <FontAwesomeIcon className="iconSocial" icon={faTiktok} onClick={() => handleClickSocials("tiktok")} />
                </div>
                
                <nav className="div-mobile-liens-page-banner">
                    <span className="lmj-title" onClick={() => clickNavBarItem("")}>Accueil</span>
                    <span className="lmj-title" onClick={() => clickNavBarItem("collections")}>Collections</span>
                    <span className="lmj-title" onClick={() => clickNavBarItem("creations-personnalisees")}>Créations Personnalisées</span>
                    <span className="lmj-title" onClick={() => clickNavBarItem("apropos")}>A propos</span>
                    <span className="lmj-title" onClick={() => clickNavBarItem("contact")}>Contact</span>
                </nav>
                
                <div className="mobile-user-actions">
                    <div className="div-icon-login-navbar" onClick={() => setProfilClique(true)}>
                        <FontAwesomeIcon id="icon-user-a" icon={faUser} style={{width: "36px", height: "36px"}} />
                        <p className="name-under-login-icon-navbar">{name ? name : "Me connecter"}</p>
                    </div>

                    <div className="icon-header-container" onClick={() => { setMobileMenuClique(false); navigate('/panier'); }}>
                        <div className="div-icon-basket-navbar">
                            <img
                                src="https://res.cloudinary.com/dc1p20eb2/image/upload/v1715033488/Anne%27so%20Naturelle/Image/basket.svg"
                                alt="icone panier"
                                id="icone_panier" style={{width: "40px", height: "40px"}}
                            />
                            {nbArticles > 0 && <span className="span-nb-articles">{nbArticles}</span>}
                        </div>
                        <p className="name-under-basket-icon-navbar">Panier</p>
                    </div>
                </div>
                
                {jwtToken && <ButtonDeconnect />}
            </div>
        </header>
    );
}

export default Banner;
